module.exports = __webpack_public_path__ + "media/images/avatar-grey-26a89a50.png";